import React, { useEffect, useState } from 'react';
import { Report, Page } from 'powerbi-client';
import FloatingPanel from 'antd-mobile/cjs/components/floating-panel';
import List from 'antd-mobile/cjs/components/list';


interface NavigationListOption {
  report: Report;
}

export default function NavigationList({ report }: NavigationListOption) {
  const [pages, setPages] = useState<Array<Page> | undefined>(undefined);

  const refreshPages = async () => {
    setPages(await report.getPages());
  }

  useEffect(() => {
    refreshPages();
  }, []);

  useEffect(() => {
    refreshPages();
  }, [report]);

  const handleClick = async (pageName: string) => {
    await report.setPage(pageName);
    await refreshPages();
  };

  const anchors = [28, window.innerHeight * 0.4, window.innerHeight * 0.6, window.innerHeight * 0.8];

  return (
    <FloatingPanel anchors={anchors}>
      <List header='Páginas del reporte'>
        {pages?.map((page: Page, index: number) => (
            <List.Item
              key={index}
              onClick={async () => handleClick(page.name)}
              disabled={page.isActive}
              style={{
                fontWeight: page.isActive ? 'bold' : 'normal',
                textDecoration: 'none',
              }}
            >{page.displayName}
            </List.Item>
        ))}
      </List>
    </FloatingPanel>
  );
}
